import { useQuery } from 'react-query';
import { useZoneContext } from '../../contexts/useZoneContext';

export const useGetEntityConversations = (entityTypeId: number, entityGuid: string) => {
    const { zoneApiClient } = useZoneContext();
    return useQuery({
        queryKey: ['get-entity-conversations', { entityTypeId, entityGuid }],
        queryFn: async () => {
            const response = await zoneApiClient.getEntityConversations(entityTypeId, entityGuid);

            if (response.httpResponse.status === 401) {
                window.location.reload();
            }

            if (response.httpResponse.status === 500) {
                throw new Error('Failed to retrieve entity conversations.');
            } else if (response.errorMessage) {
                throw new Error(response.errorMessage);
            }

            return response.payload;
        },
        enabled: !!entityGuid,
    });
};
